module.exports = __webpack_public_path__ + "static/typescriptrxjs-bg-0566e1335c2f3730a18d2a6d529cd11d.png";